export const PLANS = {
  STARTER: 'Starter',
  BETTER: 'Pro',
  BEST: 'Enterprise',
  // legacy plan names
  ELD_STARTER: 'ELD Starter',
  ELD_PLUS: 'ELD Plus',
};
